import { UserRole } from '../multi-stage-assignment-report/store/multi-stage-assignment-report.model';

export enum LstPostMessageAction {
    CLOSE = 'CLOSE',
    GET_USER_PROFILE = 'GET_USER_PROFILE',
    LOAD_COMPLETE = 'LOAD_COMPLETE',
    LOAD_NEXT_QUESTION = 'LOADNEXTQUESTION',
    LOAD_PREV_QUESTION = 'LOADPREVQUESTION',
    LOAD_QUESTION = 'LOAD_QUESTION',
    PENPAL_CONNECTION_CREATED = 'PENPAL_CONNECTION_CREATED',
    RESIZE_PAGE = 'RESIZE_PAGE',
    NAVIGATION = 'NAVIGATION',
    REQUEST_RBS_TOKEN = 'REQUEST_RBS_TOKEN',
    RBS_TOKEN = 'RBS_TOKEN',
}

export interface LstPostMessageConnection {
    destroy: () => void;
    sendMessage: (action: LstPostMessageAction, payload: LstPostMessagePayload) => Promise<any>;
}

export interface CloseActionPayload {
    closeActionResponse: boolean | void;
}

export interface UserProfilePayload {
    userProfile: {
        role: string;
    };
}

export interface GetUserProfileEvent {
    action: LstPostMessageAction;
    userProfile: {
        role: UserRole;
    };
}

export interface ResizePagePayload {
    resize_height: number;
}

export interface NavigationPayload {
    url: string;
}

export interface LoadQuestionPayload {
    questionId: string;
    assessmentSessionId: string;
    sequence: any;
}

export interface LoadQuestionFromAssessmentsViewerPayload {
    assessmentSessionId: string;
    classId: string;
    questionPosition: number;
    programNames: string[];
}

// Keep adding more types with OR operator for payload based on usage in other places.
export type LstPostMessagePayload =
    | CloseActionPayload
    | UserProfilePayload
    | ResizePagePayload
    | NavigationPayload
    | LoadQuestionPayload
    | LoadQuestionFromAssessmentsViewerPayload;

export interface LstPostMessage {
    action: LstPostMessageAction;
    payload?: LstPostMessagePayload;
}
